import { Sparkles, Gem, MessagesSquare } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const BLOCKS = [
  {
    n: "01",
    icon: Sparkles,
    title: "Variedad sin límites",
    text: "Desde colorantes e ingredientes especializados hasta moldes y boquillas de precisión. Todo lo que buscas para tus proyectos pasteleros.",
    accent: "bg-blush text-rose",
    testid: "value-prop-card-1",
  },
  {
    n: "02",
    icon: Gem,
    title: "Calidad que garantiza tus ventas",
    text: "Herramientas y accesorios de nivel profesional que facilitan tu trabajo y mejoran la presentación de tus creaciones.",
    accent: "bg-[#FFF4E5] text-gold",
    testid: "value-prop-card-2",
  },
  {
    n: "03",
    icon: MessagesSquare,
    title: "Asesoría local en Guayaquil",
    text: "Te ayudamos a elegir los insumos correctos para tus recetas. Visítanos en Plaza Quil o escríbenos directamente.",
    accent: "bg-mint text-[#3E7C4F]",
    testid: "value-prop-card-3",
  },
];

export default function ValueProps() {
  return (
    <section id="beneficios" className="relative py-14 sm:py-18 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-8">
            <Reveal>
              <Eyebrow>¿Por qué comprar en Global Pastel?</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 max-w-2xl font-display text-3xl font-semibold leading-tight tracking-tight text-choco sm:text-4xl lg:text-5xl">
                Tu aliado estratégico en la cocina y la repostería
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="lg:col-span-4">
            <p className="font-hand text-2xl leading-snug text-rose sm:text-3xl">
              Todo lo que necesitas, sin perder tiempo buscando en varios
              locales.
            </p>
          </Reveal>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3 lg:gap-7">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.n} delay={i * 0.12} className="h-full">
              <article
                data-testid={b.testid}
                className="group relative flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-linebr bg-white p-6 transition duration-300 hover:-translate-y-2 hover:shadow-[0_30px_60px_-30px_rgba(217,72,104,0.35)] sm:p-7"
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute -right-2 -top-6 font-display text-[6.5rem] font-bold italic text-cream2 transition duration-500 group-hover:text-blush"
                >
                  {b.n}
                </span>
                <span
                  className={`relative flex h-12 w-12 items-center justify-center rounded-2xl ${b.accent} transition duration-300 group-hover:scale-110 group-hover:rotate-6`}
                >
                  <b.icon className="h-6 w-6" />
                </span>
                <h3 className="relative mt-5 font-display text-xl font-semibold text-choco sm:text-2xl">
                  {b.title}
                </h3>
                <p className="relative mt-2.5 text-[15px] leading-relaxed text-cocoa">
                  {b.text}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
